import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import {
  Add,
  Button,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { DottedText } from '../../../core-utils/helper-utils/financialForensicsHelper';

type EmployeeCountTableType = {
  tableTitle: string;
  headerRowColor: string;
  columns: string[];
  rowsData: any[];
  handleOnClick: any;
};

const EmployeeCountTable: React.FC<EmployeeCountTableType> = ({
  tableTitle,
  headerRowColor,
  columns,
  rowsData,
  handleOnClick,
}) => {
  const { classes } = makeStyles()({
    tableContainer: {
      marginTop: '0.5rem',
      border: '1px solid ' + patientAccessTheme.palette.grey[300],
    },
    tableRow: {
      backgroundColor: patientAccessTheme.palette.grey[700],
      height: '36px',
      color: patientAccessTheme.palette.status.white,
    },
    cell: {
      padding: '8px 18px 8px 20px',
      borderRight: '1px solid ' + patientAccessTheme.palette.grey[300],
      borderBottom: '1px solid ' + patientAccessTheme.palette.grey[300],
      '&:last-child': {
        borderRight: 'none',
      },
      textAlign: 'center',
    },
    header: {
      backgroundColor: headerRowColor,
    },
  })();

  return (
    <TableContainer className={classes.tableContainer}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell
              className={`${classes.header} ${classes.cell}`}
              colSpan={columns.length}
            >
              <Typography
                fontSize="14px"
                fontType="medium"
                textColor={patientAccessTheme.palette.status.white}
              >
                {tableTitle}
              </Typography>
            </TableCell>
          </TableRow>

          {columns.length > 0 && (
            <TableRow className={classes.tableRow}>
              {columns.map((item) => (
                <TableCell
                  className={classes.cell}
                  style={{ width: `${100 / columns.length}%` }}
                >
                  <Typography
                    fontSize="14px"
                    fontType="medium"
                    textColor={patientAccessTheme.palette.status.white}
                  >
                    {item}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          )}
        </TableHead>

        <TableBody>
          <TableRow>
            {rowsData.length > 0 ? (
              rowsData.map((item) => (
                <TableCell className={classes.cell}>
                  {item > 0 ? (
                    <DottedText text={item} onClick={handleOnClick} />
                  ) : (
                    <Button
                      startIcon={
                        <Add fill={patientAccessTheme.palette.primary[500]} />
                      }
                      label={'Add Details'}
                      width="150px"
                      onClick={handleOnClick}
                    />
                  )}
                </TableCell>
              ))
            ) : (
              <TableCell className={classes.cell} colSpan={columns.length}>
                <Button
                  startIcon={
                    <Add fill={patientAccessTheme.palette.primary[500]} />
                  }
                  label={'Add Details'}
                  width="150px"
                  onClick={handleOnClick}
                />
              </TableCell>
            )}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default EmployeeCountTable;
